// removed by extract-text-webpack-plugin
module.exports = {"brand":"#2f75c1","wolf":"#dcdee2","hasUnaffiliated":"GroupSchoolSelect__hasUnaffiliated___PWm4d","schoolSelect":"GroupSchoolSelect__schoolSelect___3QKb3","schoolMenu":"GroupSchoolSelect__schoolMenu___3tp-m"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupSchoolSelect.css
// module id = 1226
// module chunks = 4